// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b94d06a7","891":"4669ffe1"}[chunkId] + ".chunk.js";
};